<template>
  <div class="city-list">
    <div slot="bread">
</div>
    <list-page-header :page-info="pageInfo">
     <div slot="bread">
   <router-link :to="{ name: 'home' }" class="color-white mytitle">holywoodskyline.com</router-link><span class="mytitle"> / </span>
</div>
      <div class="hero-search__left">
        <div class="hero-search__select fw">
          <v-select :options="city" placeholder="Select Genre" @onselect="selectGenre"/>
        </div>
      </div>
      <v-link
        :to="searchUrl"
        class="hero-search__submit green"
        icon="icon-search"
        icon-position="left"
        title="SEARCH MOVIE"
        @click.native="selectGenre"
      />
    </list-page-header>    
    <div class="city-list__inner">     
      <container>
        <div class="section__title fw text-center"><span class="color-light-green">Popular</span> Genres</div>
      <ContentLoader v-if="!featuredGenres && !mobileCheck"
      :height="500">
        <rect x="2" y="0" rx="3" ry="3" width="195" height="70" />
        <rect x="202" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="0" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="75" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="75" rx="3" ry="3" width="95" height="70" />       
      </ContentLoader>
      <ContentLoader v-if="!featuredGenres && mobileCheck"
      :height="400">
        <rect x="2" y="0" rx="3" ry="3" width="400" height="400"/>     
      </ContentLoader>      
        <div class="city-list__list">
          <div
            v-for="(genre, $index) in featuredGenres"
            :key="genre.id"
            class="city-list__col"
            :class="[$index === 0 ? 'col-xl-6 col-lg-6 col-md-6' : 'col-xl-3 col-lg-3 col-md-3']">
            <CityCard
              :city="genre"
            />
          </div>
        </div>

        <div class="city-list-result">
          <div class="result-bracket">
            <div class="result-bracket__title">
              <span class="result-bracket__count" v-if="genres">{{ genres.length }}</span> Genres Found!
            </div>
          </div>
      <ContentLoader v-if="!genres && !mobileCheck"
      :height="400">>
        <p>&nbsp;</p>
        <rect x="2" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="202" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="0" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="75" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="75" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="150" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="150" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="150" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="150" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="225" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="225" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="225" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="225" rx="3" ry="3" width="95" height="70" />           
      </ContentLoader>

      <ContentLoader v-if="!cities && mobileCheck">
        <rect x="3" y="0" rx="3" ry="3" width="376" height="440" />      
      </ContentLoader>

          <div class="city-list-result__list flex-row">
            <div class="city-list-result__item col-xl-3 col-md-4"
                 v-for="genre in genres"
                 :key="genre.id">
              <router-link :to="{ name: 'City', params: { id: genre.id, city: genre.slug, genre: genre.name }}" @click.native="onSelect(genre)">
                <CityInfoCard
                  :city="genre"
                />
              </router-link>
            </div>

            <!--<div class="city-list-result__bottom fw text-center">-->
              <!--<v-link-->
                <!--to="/yurtlar"-->
                <!--class="button&#45;&#45;stroke round icon-transform"-->
                <!--title="Daha Fazla Gör"-->
                <!--icon="icon-arrow-long-right"-->
                <!--icon-position="right"-->
              <!--/>-->
            <!--</div>-->
          </div>
        </div>
      </container>
    </div>
  </div>
</template>

<script>
import ListPageHeader from '@/components/ListPageHeader'
import CityCard from '@/components/CityCard'
import CityInfoCard from '@/components/CityInfoCard'
import { ContentLoader } from 'vue-content-loader'
import axios from 'axios'
export default {
  name: 'CityList',
  components: {
    ListPageHeader, CityCard, CityInfoCard, ContentLoader
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Genres',
       meta: [
         { vmid: 'description', name: 'description', content: this.pageInfo.text },
         { vmid: 'keywords', name: 'keywords', content: 'movie, hollywood movies, italian movies, superhero movies ,american movies, holywoodskyline, search movie' }
       ],
       link: [
         { vmid: 'canonical', rel: 'canonical', href: window.location.origin + '/genres' }
       ]      
    }
  },  
  data () {
    return {
      pageInfo: {
        icon: require('@/assets/img/icon-city.svg'),
        // title: '<span class="color-light-green">Choose Your </span> Movie Genre!',
        title: '<span class="color-light-green">holywood</span>skyline',
        text: '' //'You can find movies in your city, can track movie information, can learn prices and buy tickets !'
      },
      city: [],
      cityID: null,
      genres: [
    {
      id: 28,
      name: "Action",
      slug: 'action'
    },
    {
      id: 12,
      name: "Adventure",
      slug:'adventure'
    },
    {
      id: 16,
      name: 'Animation',
      slug: 'animation'
    },
    {
      id: 35,
      name: "Comedy",
      slug:'comedy'
    },
    {
      id: 80,
      name: "Crime",
      slug: 'crime'
    },
    {
      id: 99,
      name: "Documentary",
      slug: 'documentary'
    },
    {
      id: 18,
      name: "Drama",
      slug: 'drama'
    },
    {
      id: 10751,
      name: "Family",
      slug: 'family'
    },
    {
      id: 14,
      name: "Fantasy",
      slug: 'fantasy'
    },
    {
      id: 36,
      name: "History",
      slug: 'history'
    },
    {
      id: 27,
      name: "Horror",
      slug: 'horror'
    },
    {
      id: 10402,
      name: "Music",
      slug: 'music'
    },
    {
      id: 9648,
      name: "Mystery",
      slug: 'mystery'
    },
    {
      id: 10749,
      name: "Romance",
      slug: 'romance'
    },
    {
      id: 878,
      name: "Science Fiction",
      slug:'science-fiction'
    },
    {
      id: 10770,
      name: "TV Movie",
      slug:'tv'
    },
    {
      id: 53,
      name: "Thriller",
      slug: 'thriller'
    },
    {
      id: 10752,
      name: "War",
      slug: 'war'
    },
    {
      id: 37,
      name: "Western",
      slug: 'western'
    }
  ],
      searchUrl: {},
      errors: [],
      featuredGenres: [
      {
      title: "Animation",
      backdrop_path: "/9DA9dxRE0fRlpl4amBmLCjQdZay.jpg",
      id: 18,
      name: "animation",
      original_language: "en",
      original_name: "Ultimate Avengers Collection",
      overview: "When a nuclear missile was fired at Washington in 1945, Captain America managed to detonate it in the upper atmosphere. But then he fell miles into the icy depths of the North Atlantic, where he remained lost for over sixty years. But now, with the world facing the very same evil, Captain America must rise again as our last hope for survival.",
      poster_path: "/bOXJmKCHKtqJILiJ5womPDigEoc.jpg"
    },
    {
      title: "Science Fiction",
      backdrop_path: "/zuW6fOiusv4X9nnW3paHGfXcSll.jpg",
      id: 878,
      name: "science-fiction",
      original_language: "en",
      original_name: "Alien Avengers Collection",
      overview: "Alien Avengers (Welcome to Planet Earth) and Alien Avengers II (Aliens Among Us)",
      poster_path: null
    },
    {
      title: "Horror",
      backdrop_path: "/zuW6fOiusv4X9nnW3paHGfXcSll.jpg",
      id: 27,
      name: "horror",
      original_language: "en",
      original_name: "The Avengers Collection",
      overview: "A superhero film series produced by Marvel Studios based on the Marvel Comics superhero team of the same name, and part of the Marvel Cinematic Universe (MCU).  The series features an ensemble cast from the Marvel Cinematic Universe series films, as they join forces for the peacekeeping organization S.H.I.E.L.D. led by Nick Fury.",
      poster_path: "/bvjltR2nDuhf1NlnwCrgNwvHuIh.jpg"
    },
    {
      title: "Drama",
      backdrop_path: "/tp0buiNBb6iFjlr34lCB9ardTEA.jpg",
      id: 18,
      name: "drama",
      original_language: "en",
      original_name: "Avengers Grimm Collection",
      overview: "Avengers Grimm is a 2015 American fantasy action adventure film written, co-edited, and directed by Jeremy M. Inman. The film, produced by B-movie film company The Asylum, stars Casper Van Dien, Lou Ferrigno, Kimo Leopoldo, Lauren Parkinson, Milynn Sarley, Marah Fairclough, Rileah Vanderbilt, and Elizabeth Peterson. Avengers Grimm received a direct sequel in 2018 through Avengers Grimm: Time Wars while also having gotten a loose spin-off through Sinister Squad in 2016.",
      poster_path: "/oqEp8zCTK7mTKeeEHCTCkT3pMLx.jpg"
    },
    {
      title: "Thriller",
      backdrop_path: "/zh72eVJTD5EssStCsNHqELuh6uD.jpg",
      id: 80,
      name: "thriller",
      original_language: "en",
      original_name: "Spider-Man (Avengers) Collection",
      overview: "A superhero film series based on the Marvel character Spider-Man, portrayed by Tom Holland. The series is centered on Peter Parker, an academically gifted but socially inept high school student who fights crime as Spider-Man, a member of The Avengers.",
      poster_path: "/nogV4th2P5QWYvQIMiWHj4CFLU9.jpg"
    },
    {
      title: "Crime",
      backdrop_path: "/tp0buiNBb6iFjlr34lCB9ardTEA.jpg",
      id: 80,
      name: "crime",
      original_language: "en",
      original_name: "Avengers Grimm Collection",
      overview: "Avengers Grimm is a 2015 American fantasy action adventure film written, co-edited, and directed by Jeremy M. Inman. The film, produced by B-movie film company The Asylum, stars Casper Van Dien, Lou Ferrigno, Kimo Leopoldo, Lauren Parkinson, Milynn Sarley, Marah Fairclough, Rileah Vanderbilt, and Elizabeth Peterson. Avengers Grimm received a direct sequel in 2018 through Avengers Grimm: Time Wars while also having gotten a loose spin-off through Sinister Squad in 2016.",
      poster_path: "/oqEp8zCTK7mTKeeEHCTCkT3pMLx.jpg"
    },
    {
      title: "Fantasy",
      backdrop_path: "/zh72eVJTD5EssStCsNHqELuh6uD.jpg",
      id: 14,
      name: "fantasy",
      original_language: "en",
      original_name: "Spider-Man (Avengers) Collection",
      overview: "A superhero film series based on the Marvel character Spider-Man, portrayed by Tom Holland. The series is centered on Peter Parker, an academically gifted but socially inept high school student who fights crime as Spider-Man, a member of The Avengers.",
      poster_path: "/nogV4th2P5QWYvQIMiWHj4CFLU9.jpg"
    },    
    ]
    }
  },
  methods: {
    onSelect (city) {
      // console.log(opt)
      window.localStorage.setItem('district_name', '')
      window.localStorage.setItem('studio', city.name)
      window.localStorage.setItem('genre', city.id)
    },
    selectGenre (opt) {
      // this.cityID = opt.id
      // this.searchUrl = { name: 'City', params: { slug: opt.slug, id: opt.id } }
      // console.log("sehir: " + this.$refs.myinput.value)
      // const selectedCity = this.$refs.myinput.value
      // let mycity = this.city.find(function (citty) { return citty.name == selectedCity } )
      // let slug = this.string_to_slug(this.$refs.myinput.value)
      window.localStorage.setItem('district_name', '')
      window.localStorage.setItem('studio', opt.slug)
      this.$router.push({ name: 'City', params: { city: opt.slug, id: opt.id } })
    },
    getPopularMovies () {
      let self = this
      //axios.get('/site/home/cities?take=7')
      axios.get('/3/movie/popular?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&page=1')
        .then(response => {
          self.featuredGenres = response.data.results
              self.featuredGenres.forEach((data) => {
                data.slug = string_to_slug(data.name)
            })          
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getCityList () {
      let self = this
      axios.get('/3/genre/movie/list?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US')
        .then(response => {
       //   self.genres = response.data.genres
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getCities () {
      let self = this
      axios.get('/3/discover/movie?api_key=a11ac97c6bdb99adc0845654be0902a8&with_genres=28&page=2')
        .then(response => {
           self.city = response.data.results
/*          response.data.forEach(function(element) {
          self.city.push(element.name)
         })      */
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  created () {
   // this.getPopularMovies()
  //  this.getCities()
    this.getCityList()
  },
  computed: {
    mobileCheck() {
     var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check
  },     
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/components/city-list";
</style>
